import { render, staticRenderFns } from "./RelationsAddNew.vue?vue&type=template&id=908dfb12&"
import script from "./RelationsAddNew.vue?vue&type=script&lang=js&"
export * from "./RelationsAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports